import updateCart from './updateCart';

function updateNotes({ axios, cartId, notes }) {
  return updateCart({
    axios,
    cartId,
    payload: { notes },
  });
}

export default updateNotes;
